import { Collection } from "./Collection";
import { ApiMetadata, cacheIsEmpty, getCopyOfCache, putAllInCache, putInCache } from "./ApiMetadata";

/**
 * This class exists to provide access to retrieve/remove endpoint/model metadata from the metadata cache, without
 * providing full access to the cache itself.
 */
export class ApiMetadataCacheAccessor {
    public static put(endpoint: string, metadata: ApiMetadata) {
        putInCache(endpoint, metadata);
    }

    public static getCopy(): Collection<ApiMetadata> {
        return getCopyOfCache();
    }

    public static putAll(sourceCache: Collection<ApiMetadata>) {
        putAllInCache(sourceCache);
    }

    public static isEmpty(): boolean {
        return cacheIsEmpty();
    }
}
